import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import Panel from "../../components/ui/Panel/Panel.jsx";
import Button from "../../components/ui/Button/Button.jsx";
import Tag from "../../components/ui/Tag/Tag.jsx";
import PageHeader from "../../components/marketing/PageHeader.jsx";
import SeoHead from "../../seo/SeoHead.jsx";
import { ROUTE_META, PRICE_FROM } from "../../seo/siteMeta.js";
import { breadcrumbSchema } from "../../seo/schema.js";
import { sortedPostsEs, CATEGORIES_ES } from "../../data/blogPostsEs.js";
import { plainText } from "../../seo/richText.js";

/**
 * /es - hub for the Spanish-language guides. Says up front that the filing
 * app itself is in English; the guides exist to walk Spanish speakers through
 * it. Paired with /blog via hreflang.
 */
const meta = ROUTE_META["/es"];

const EsIndex = () => {
  const posts = sortedPostsEs();
  return (
    <div className="max-w-[1000px] mx-auto px-[22px] py-[46px] pb-[70px]">
      <SeoHead
        title={meta.title}
        description={meta.description}
        path="/es"
        keywords={meta.keywords}
        lang="es"
        alternates={[{ hreflang: "en", path: "/blog" }]}
        schemas={[breadcrumbSchema([{ name: "Inicio", path: "/" }, { name: "Guías en español", path: "/es" }])]}
      />
      <div className="flex justify-end">
        <Link to="/blog" hrefLang="en" className="text-sm font-semibold text-[var(--accent)] no-underline">
          Read in English
        </Link>
      </div>
      <PageHeader eyebrow="Guías en español" title="Formulario 2290 en español">
        Guías claras sobre el impuesto sobre el uso de vehículos pesados en las carreteras: quién debe presentar, cuándo
        vence, cuánto se paga y cómo obtener su Anexo 1 estampado. La aplicación para presentar está en inglés; estas
        guías le explican cada paso en español.
      </PageHeader>

      <div className="grid gap-4 mt-8 sm:grid-cols-2">
        {posts.map((p) => (
          <Panel key={p.slug} padded className="hover:border-[var(--accent)] transition-colors">
            <Link to={`/es/${p.slug}`} className="no-underline text-inherit">
              <div className="flex flex-wrap items-center gap-2">
                <Tag tone="default">{CATEGORIES_ES[p.category]}</Tag>
                <span className="text-[var(--muted)] text-xs inline-flex items-center gap-1">
                  <Clock size={13} /> {p.readingMinutes} min de lectura
                </span>
              </div>
              <b className="font-disp text-[17px] block mt-2.5">{p.title}</b>
              <p className="text-[var(--muted)] text-sm mt-1.5">{plainText(p.excerpt)}</p>
            </Link>
          </Panel>
        ))}
      </div>

      <Panel padded className="!bg-[var(--accent-soft)] flex flex-wrap items-center justify-between gap-6 mt-11 !p-[30px]">
        <div>
          <b className="font-disp text-[19px]">Presente el Formulario 2290 desde ${PRICE_FROM}</b>
          <p className="text-[var(--muted)] text-sm mt-1 max-w-[50ch]">
            Cree su cuenta gratis. La aplicación está en inglés; la guía{" "}
            <Link to="/es/como-presentar-formulario-2290-en-linea" className="text-[var(--accent)]">cómo presentar el Formulario 2290 en línea</Link>{" "}
            le explica cada pantalla.
          </p>
        </div>
        <Link to="/login?tab=up">
          <Button>
            Crear su cuenta gratis <ArrowRight size={16} />
          </Button>
        </Link>
      </Panel>
    </div>
  );
};

export default EsIndex;
